import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface CxoneOrderManagementGridProductInterface {
  title?: string,
  imageURL?: string,
  imageID?: number,
}

@Component({
  selector: 'cxone-order-management-grid-product',
  templateUrl: './cxone-order-management-grid-product.component.html',
  styleUrl: './cxone-order-management-grid-product.component.scss'
})
export class CxoneOrderManagementGridProductComponent implements ICellRendererAngularComp {
  title?: string;
  imageURL?: string;
  imageID?: number;
  constructor() {
  }
  agInit(params: ICellRendererParams<any, any, any> & CxoneOrderManagementGridProductInterface): void {
    this.title = params.title;
    this.imageURL = params.imageURL;
    this.imageID = params.imageID;
  }
  
  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

  isTextHasEllipsis(element: HTMLElement): boolean {
    return element.scrollWidth > element.clientWidth;
  }
}
